const DEVICE_ID_PATTERN = /^[A-Z0-9]{4,32}$/;

export const DEVICE_ID_ERROR_MESSAGE =
  "裝置 ID 須為 4–32 個英數字，可含 : 或 -";

export const canonicalDeviceId = (raw) =>
  raw == null ? "" : String(raw).replace(/[:\-\s]/g, "").toUpperCase();

export const isValidDeviceId = (raw) =>
  DEVICE_ID_PATTERN.test(canonicalDeviceId(raw));

// antd Form rule; empty values are left to the `required` rule.
export const deviceIdRule = {
  validator: (_, value) =>
    !value || isValidDeviceId(value)
      ? Promise.resolve()
      : Promise.reject(new Error(DEVICE_ID_ERROR_MESSAGE)),
};

// Import CSVs accept the new header or the legacy one.
export const DEVICE_ID_CSV_HEADERS = ["裝置ID", "MAC"];

export const findDeviceIdColumn = (headers) =>
  headers.findIndex((h) => DEVICE_ID_CSV_HEADERS.includes(h));
